<figure>
    <div class="embedcontainer" [ngClass]="{ withpreview: !(showVideo$ | async) || options.overlay }">
        <ng-container *ngIf="!(showVideo$ | async) || options.overlay">
            <da-progressive-image
                [options]="{
                    alt: altText$ | async,
                    aspectRatios: aspectRatios$ | async                    
                }"
                (click)="playVideo()"
            ></da-progressive-image>
        </ng-container>
        <ng-container *ngIf="(showVideo$ | async) && !options.overlay">
            <ng-container *ngTemplateOutlet="youtubeVideo"></ng-container>
        </ng-container>
        <span class="videoplaybutton" [hidden]="(showVideo$ | async) && !options.overlay"></span>
    </div>
</figure>
<ng-template #overlay>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="youtubeVideo"></ng-container>
    </div>
</ng-template>
<ng-template #youtubeVideo>
    <iframe
        *ngIf="options.videoId"
        [src]="options.videoId | youtubeSafeUrl: 'autoplay': options.isQQVideo"
        frameborder="0"
        allowfullscreen
        allow="autoplay"
    ></iframe>
</ng-template>
